export default class DtoLithologyType {
    constructor(obj) {
        this.idStation = obj.idStation
        this.lithologyType = obj.lithologyType
    }
}